import React from "react";
import { useUser } from "./../../Home/UserContext";
import { getRoleFromRoleId } from "./../../../utils/roleHelper";
import useScrollToTop from "./../../../hooks/useScollToTop";
import DashboardNavigation from "./../../DashboardNavigation/DashboardNavigation";
import HeaderTitle from "../../../components/HeaderTitle/HeaderTitle";
import CategoriesTable from "./components/CategoriesTable";

const CategoriesPage = () => {
  useScrollToTop();
  const { user } = useUser();
  const userRole = getRoleFromRoleId(user?.role_id);

  return (
    <section className="w-full">
      <div className="pt-[150px]" aria-hidden />

      <div className="mx-auto w-full max-w-7xl px-3 sm:px-6">
        <HeaderTitle
          role="Enseignant"
          title="Catégories & Répartitions"
          align="center"
          className="mb-1"
        />

        <div className="mt-3 mb-6">
          <DashboardNavigation role={userRole} />
        </div>

        <div className="rounded-2xl overflow-hidden shadow ring-1 ring-slate-200/70 dark:ring-slate-700/70 bg-white/80 dark:bg-slate-900/60 backdrop-blur mb-4">
          <div className="bg-gradient-to-r from-blue-500 via-violet-500 to-pink-500">
            <div className="px-5 py-6 sm:px-8 text-white">
              <h1 className="text-2xl font-semibold text-center">
                Tableau des Catégories d&apos;Âge et de Poids
              </h1>
              <div className="mt-3 text-sm/6 max-w-3xl mx-auto text-center">
                <p>
                  Consulte les répartitions par catégories d’âge et de poids,
                  ou bascule vers une <strong>vue tableau adhérents</strong>
                  pour visualiser chaque judoka avec sa date de naissance,
                  sa catégorie d’âge, son poids et sa catégorie de poids.
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="bg-gray-50 dark:bg-gray-900 border border-gray-200 dark:border-gray-700 rounded-xl p-4">
          <CategoriesTable />
        </div>
      </div>
    </section>
  );
};

export default CategoriesPage;